<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <header class="header-container sg-center-padding"> -->
    <div :class="className">
      <router-view name="nav" />
    </div>

    <!-- </header> -->
    <!-- <div class="search-container sg-center-padding"> -->
    <router-view name="search" />
    <!-- </div> -->

    <Mine v-bind="$attrs" />

    <router-view name="rightPanel" />
    <footer class="footer-container">
      <div class="footer-center-container sg-center-padding">
        <!-- <router-view name="footerTop" /> -->
        <router-view name="footerCenter" />
      </div>
      <router-view name="footerBottom" />
    </footer>
  </div>
</template>

<script>
import Mine from "@/views/buyer/index";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";

export default {
  name: "Layout",
  props: {
    className: String,
  },
  components: {
    Mine,
  },
  // props:{
  //   className:String
  // },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        // withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  // created(){
  //   let test=this.className
  //   debugger
  // },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  min-height: 100%;
  width: 100%;
  background-color: #f2f4f5;
  display: flex;
  flex-direction: column;
  // .header-container {
  //   padding: 0 calc(50% - 600px);
  // }
  .search-container {
    background-color: #fff;
    // padding: 0 calc(50% - 600px);
    overflow: hidden;
  }

  .footer-container {
    background-color: #fff;
    .footer-center-container {
      // padding: 0 calc(50% - 600px);
    }
  }

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  // width: calc(100% - #{$sideBarWidth});
  // transition: width 0.28s;
}

.hideSidebar .fixed-header {
  // width: calc(100% - 54px)
}

.mobile .fixed-header {
  width: 100%;
}
</style>
